import React, { memo } from 'react';

// components
import Applications from 'modules/Connections/Applications';

const ApplicationsPage = memo(() => {
  return <Applications />;
});

export default ApplicationsPage;
